import { RhSelectOption } from '../modules/core/RhSelect';

/**
 * null as a return value is intentional
 * so that RhSelect will display "Select" as a placeholder
 */
export const getSelectValue = (
  value: number | string | null | undefined
): RhSelectOption | null => {
  return value ? { label: value + '', value: value + '' } : null;
};
